export default function shallowCompare(source, target) {
  const keys = [];

  Object.keys(target).forEach(key => {
    if (target[key] !== source[key]) {
      keys.push(key);
    }
  });

  return keys;
}
